export default {
  common: {
    clearAll: 'Tümünü temizle',
    required: 'Gerekli',
    restart: 'Yeniden Başlat'
  },
  createUser: {
    acceptTermsAndConditions: 'Şartlar ve koşulları kabul edin',
    alreadyHaveAccount: 'Zaten bir hesabın var mı? %{pre}İndir%{post}',
    checkEmail: "Bu arada, Metrica Play'i bilgisayarınıza indirin",
    clubCompany: 'Kuruluş/Kulüp',
    createdSuccessfully:
      'Kayıt başarılı! Bir doğrulama bağlantısı için kayıtlı e-postanızı kontrol edin. (Gereksiz/spam klasörünü kontrol edin)',
    email: 'E-posta',
    invalidEmail: 'Geçersiz e-posta',
    job: 'İş/Rol',
    lastName: 'Soyadı',
    name: 'Adı',
    noCustomOption: 'Seçenek mevcut değil',
    noMatches: 'Eşleşme yok, kendi seçeneğinizi yazın',
    password: 'Parola',
    passwordsDontMatch: 'Parolalar eşleşmiyor',
    passwordInvalid: 'Parola gereksinimleri karşılamıyor',
    passwordRequirements: {
      minLength: 'En az %{count} karakter',
      uppercase: 'Bir büyük harf',
      lowercase: 'Bir küçük harf',
      number: 'Bir rakam (0-9)',
      maxLength: 'En fazla %{count} karakter'
    },
    phone: 'Telefon',
    phoneCode: 'Ülke',
    proceed: 'Devam et',
    repeatPassword: 'Parolayı tekrarla',
    searchPhoneCode: 'Ara...',
    seeTermsAndConditions: 'Şartlar ve koşulları görün',
    signAgreement:
      'Metrica Sports hesabına kaydolmak, %{pre1}Gizlilik Politikası%{post1} ve %{pre2}Hizmet Şartları%{post2}nı kabul ettiğin anlamına gelir',
    signUpHere: 'Başlamak için hesabınızı oluşturun.',
    sport: 'Spor',
    submitting: 'Başlatılıyor...',
    title: '%{product} ile başlayın',
    userKeyField: 'Promosyon Kodunuz veya Kullanıcı Anahtarınız mı var? Bu alanı doldurun'
  },
  error: {
    downloadPlay: "Zaten bir hesabınız varsa, Play'in en son sürümünü indirin ve giriş yapın.",
    emailTaken: 'Bu e-posta zaten alınmış',
    fieldTooLong: 'Bazı alanlar çok uzun. Kısaltıp tekrar deneyin',
    oops: 'Hay aksi!',
    restart: 'Görünüşe göre hala geliştirmekte olduğumuz bir yere girmeyi deniyorsun...',
    tryAgain:
      'Lütfen tekrar deneyin. Eğer bu hata devam ederse, Metrica Sports destek ekibiyle iletişime geçin',
    userKey:
      'Anahtar geçerli değil. Anahtarınızı kontrol edip tekrar deneyin veya kaydı tamamlamak için alanı silin'
  },
  invitation: {
    acceptButton: 'Hesabımın Değişikliğini Kabul Ediyorum',
    accepting: 'Kabul Ediliyor...',
    cancelButton: 'Reddet',
    description1:
      'Yeni Metrica Sports hesabına eklendiğinde, mevcut Metrica Sports hesabının (ve içindeki bilgilerin) mülkiyeti yeni Metrica Sports hesabı sahibine aktarılacak ve atanacaktır. Metrica Sports hesabınızda şu anda bulunan tüm bilgi ve veriler, hesap değişikliğini kabul ettikten sonra kaydedilen herhangi bir bilgi veya veri ile birlikte, yeni Metrica Sports hesabı sahibi ve bu hesaptaki herhangi bir yönetici(ler) tarafından görülebilir ve kullanılabilir olacak ve hesap sahibinin takdirine bağlı olarak diğerleriyle paylaşılabilir.',
    description2:
      '"Acepto el cambio de mi cuenta" butonuna tıklayarak aşağıdakileri kabul etmiş ve yetkilendirmiş olursunuz:',
    list1: 'Mevcut hesap bilgileriniz yeni Metrica Sports hesabına aktarılacak.',
    list2:
      'Mevcut hesabınızdan yeni Metrica Sports hesabınıza aktarılan tüm hesap bilgileri, yeni hesap sahibi ve/veya yönetici(ler) tarafından yönetilebilir.',
    list3:
      'Yeni Metrica Sports hesabınızda rolünüz "Üye" olacak. Mevcut hesabınızdan sahip veya yönetici ayrıcalıklarına artık sahip olmayacaksınız.',
    list4:
      'Yeni Metrica Sports hesabınızın mevcut ayarlarını devralacaksınız, bu ayarlar hesaptaki rolünüze bağlı olarak daha fazla veya daha az kısıtlayıcı olabilir ve ayarlarınız yeni Metrica Sports hesabı sahibi veya yönetici(ler)i tarafından yönetilebilir.',
    list5:
      'Mevcut ayarlarınız, katıldığınız yeni hesapta bulunan ayarlarla çakışıyorsa değiştirilebilir.',
    list6:
      'Yeni hesabınız, mevcut hesabınızda sahip olduğunuz tüm özelliklere erişim sağlamayabilir.',
    list7:
      'Hesap transferinizi başlattıktan sonra geri almanız mümkün değildir ve tüm hesap bilgileriniz tek bir hesapta kalacaktır.',
    list8:
      "“Hesabımın Değişikliğini Kabul Ediyorum”a tıklayarak, %{pre1}%{email}%{post1} hesabının yönetilen bir üyesi olacak ve Metrica Sports'un %{pre2}Hizmet Şartları%{post2} ve %{pre3}Gizlilik Beyanı%{post3}nı kabul etmiş olacaksınız.",
    subtitle:
      'Bu yeni Metrica Sports hesap davetini kabul ederek, başka bir Metrica Sports hesabına ekleneceksiniz.',
    title: 'Davetiye'
  },
  jobs: {
    academyDirector: 'Akademi Direktörü',
    assistantCoach: 'Yardımcı Antrenör',
    dataAnalyst: 'Veri Analisti',
    doctor: 'Doktor',
    formerPlayer: 'Eski Oyuncu',
    goalkeeperCoach: 'Kaleci Antrenör',
    headCoach: 'Teknik Direktör',
    journalist: 'Gazeteci',
    other: 'Diğer',
    performance: 'Fitness ve Performans',
    player: 'Oyuncu',
    scout: 'Scout/İzleyici Antrenör',
    sportsDirector: 'Sportif Direktör',
    student: 'Öğrenci',
    videoAnalyst: 'Video Analisti'
  },
  sports: {
    americanFootball: 'Amerikan futbolu',
    baseball: 'Beyzbol',
    basketball: 'Basketbol',
    fieldHockey: 'Çim Hokeyi',
    football: 'Futbol',
    futsal: 'Futsal',
    gaelicFootball: 'Gal futbolu',
    handball: 'Hentbol',
    iceHockey: 'Buz hokeyi',
    lacrosse: 'Lakros',
    netball: 'Netball',
    other: 'Diğer',
    padel: 'Padel',
    rugby: 'Rugby',
    tennis: 'Tenis',
    volleyball: 'Voleybol'
  }
}
